import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min — CMS-driven content
      gcTime: 30 * 60 * 1000, // 30 min
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});